import { ViewIds } from '@ardoq/api-types';
import {
  getSupportedTraversalViewIdOrDefault,
  toRenderedViewpointViewId,
} from 'views/environmentals/getViewpointModeSupportedViews';

// The view id actually rendered for a stored viewpoint/slide view id: the
// supported-view fallback (e.g. an unavailable FBD → Block Diagram) followed by
// the FBD-as-Block-Diagram reroute (ARD-33096).
const toEffectiveViewpointViewId = (viewId?: ViewIds): ViewIds =>
  toRenderedViewpointViewId(getSupportedTraversalViewIdOrDefault(viewId));

/**
 * For a viewpoint's stored view id + settings, the id actually rendered and the
 * settings passed through unchanged — FBD settings are a strict superset of
 * Block Diagram's (ARD-33247), so the reroute needs no conversion.
 */
export const toRenderedViewpointViewSettings = (
  storedViewId: ViewIds,
  storedSettings: Record<string, unknown>
): { viewId: ViewIds; settings: Record<string, unknown> } => ({
  viewId: toEffectiveViewpointViewId(storedViewId),
  settings: storedSettings,
});
